
module.exports = function(req, next){
  sessionStorage.setItem("searchUrl",window.location.href.split("?")[1]);
  if (req.query && req.query.entitlementId) {
      sessionStorage.setItem("entitlementId",req.query.entitlementId);
  }else{
      sessionStorage.removeItem("entitlementId");
  }
  if (req.query && req.query.callBack) {
      sessionStorage.setItem("callBack",req.query.callBack);
  }else{
      sessionStorage.removeItem("callBack");
  }
  if (req.query && req.query.authId) {
      sessionStorage.setItem("authId",req.query.authId);
  }else{
      sessionStorage.removeItem("authId");
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/routes/callback/sso.js
// module id = 182
// module chunks = 0